export default [
  {
    path: '/app/reminders',
    name: 'Reminders',
    component: () => import('@/views/Admin/Reminders/Index.vue'),
    meta: {
      pageTitle: 'Hatırlatmalar',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_REMINDER_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/reminders/edit/:id',
    name: 'ReminderEdit',
    component: () => import('@/views/Admin/Reminders/Edit.vue'),
    meta: {
      pageTitle: 'Hatırlatmalar',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/reminders',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_REMINDER_EDIT',
      action: 'read',
    },
  },
]
